









































































































































































































































import { defineComponent, ref } from '@vue/composition-api';
import { useData, useHasFreeQuotes } from './Checkout.hooks';
import { Notify } from 'quasar';
import { productLocale } from '@ligo/shared/mvc';
import OrderList from './OrderList.vue';
import NewContactCard from '../../components/base/NewContactCard.vue';
import BackButton from '../../components/base/BackButton.vue';
import NextButton from '../../components/base/NextButton.vue';
import { useLocaleTools } from '../../components/layout/locale-hooks';
import { RESOURCES } from '@ligo/bv-flow/store';
import BvAlertBanner from '../../components/base/BvAlertBanner.vue';
import { PaymentService } from '@ligo/bv-flow/services';
import { BvLayoutPageInformation } from '@ligo/bv-flow/hooks';

const IMAGE_PAYMENT = '/questionnaire/images/payments.svg';
const ICON_CHECK = 'img:/questionnaire/icons/radio_check.svg';
const ICON_UNCHECK = 'img:/questionnaire/icons/radio_uncheck.svg';
const HEIGHT_MD = 40;
const HEIGHT_SM = 60;

export default defineComponent({
  name: 'Checkout',
  components: {
    OrderList,
    NewContactCard,
    BackButton,
    NextButton,
    BvAlertBanner
  },
  props: {
    slug: String,
    uid: String
  },
  setup(props, { root }) {
    const { changeLanguage } = useLocaleTools(root);
    const {
      t: bvConfig,
      isReady: isConfigReady,
      te: bvConfigExists
    } = BvLayoutPageInformation;

    const {
      loading: freeLoading,
      hasBookkepper,
      load: loadFreeQuotes
    } = useHasFreeQuotes();

    const {
      loading,
      checkoutData,
      checkoutProductFormRef,
      criminalRecordsLabel,
      notaryProduct,
      CATEGORIES_ORDER,
      goBack
    } = useData(props.uid, props.slug, root, (notaryProduct) => {
      loadFreeQuotes(notaryProduct);
    });

    const extraCheckboxTextExists = () => {
      return bvConfigExists('steps.checkout.extra_checkbox');
    };

    const extraCheckboxText = () => {
      return bvConfig('steps.checkout.extra_checkbox');
    };
    const extraCheckboxValue = ref(false);

    changeLanguage(notaryProduct.value.language);
    const termsAndConditions = ref(false);
    function checkboxChange() {
      void checkoutProductFormRef.value.save(false);
    }
    function changeApproval(value) {
      checkoutProductFormRef.value.fields.lead_approval.value = value;
    }
    const finish = async () => {
      if (
        checkoutProductFormRef.value.fields.criminal_record_status.value &&
        termsAndConditions.value
      ) {
        loading.value = true;
        await checkoutProductFormRef.value.save();
        const paymentUuid = checkoutData.value.payment?.uuid;
        const response = await PaymentService.createMolliePayment(paymentUuid);
        window.open(response.data.payment_link, '_top');
      } else {
        const alertLocale = !checkoutProductFormRef.value.fields
          .criminal_record_status.value
          ? 'preview_order.criminal_record_alert'
          : 'preview_order.terms_and_conditions_alert';
        Notify.create({
          message: root.$i18n.t(
            productLocale(notaryProduct.value, alertLocale)
          ) as string,
          color: 'surface-critical',
          position: 'top',
          icon: 'mdi-alert',
          classes: 'bv-notify'
        });
      }
    };
    return {
      loading,
      checkoutData,
      extraCheckboxValue,
      isConfigReady,
      checkoutProductFormRef,
      criminalRecordsLabel,
      notaryProduct,
      productLocale,
      termsAndConditions,
      checkboxChange,
      extraCheckboxTextExists,
      finish,
      CATEGORIES_ORDER,
      goBack,
      changeApproval,
      RESOURCES,
      IMAGE_PAYMENT,
      HEIGHT_SM,
      ICON_CHECK,
      ICON_UNCHECK,
      HEIGHT_MD,
      freeLoading,
      hasBookkepper,
      extraCheckboxText
    };
  }
});
